// Module
var code = `<ex-mono-occurrence-ecran formulaire="vm.formulaireDfb" mono-occurrence-options="vm.monoOccurrenceOptions"> </ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;